<template>
  <div
      class="sm-search sm-search_mobile"
      :class="{'sm-search_attached': !isAutocompleteMode, 'sm-search_attached_full': false}"
  >
    <form class="sm-search__form sm-search-form">
      <div class="sm-search-form__input-block">
        <input type="text"
               name="q"
               autocomplete="off"
               autocorrect="off"
               autocapitalize="off"
               spellcheck="false"
               class="sm-search-form__input"
               id="search-input-vue-mobile"
               data-target="_self"
               v-model="q_param"
               v-on:input="debounceInput"
               @click="doStart"
               @keypress.enter="onSearch"
        />
        <div class="sm-search-form__actions">
          <button @click.prevent="onClear" type="button" class="sm-search-form__clear"></button>
          <button @click.prevent="onSearch" type="button" class="sm-search-form__submit">
            <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" stroke="white" stroke-width="1.5" stroke-miterlimit="10" fill="none" class="sm-search-form__icon"><use xlink:href="#magnifier"></use></svg>
          </button>
        </div>
      </div>
      <button @click="hideMe" type="button" class="sm-search-form__close">
        Закрыть
      </button>
    </form>
    <Tips v-if="false"></Tips>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import _ from 'lodash'
import Tips from './grid/tips.vue';

export default {
  name: "sm-search-mobile",
  computed: {
    ...mapGetters("search",[ "q", "isAutocompleteMode"]),
    q_param: {
      get: function () {
        return this.q;
      },
      set: function (value) {
        this.setQString(value);
      }
    }
  },
  methods: {
    ...mapActions("search", [
        "closeSearch",
        "autocomplete",
        "changeMode",
        "setQString",
        "addToHistory",
        "selectCategory",
        "resetFilters",
        "doSearch",
        "setSearchMode"

    ]),
    doStart() {
      console.log('doStart')
      this.changeMode('start');
    },
    onSearch() {
      // пишем q в localStorage
      this.addToHistory()
      this.selectCategory(0)
      this.resetFilters()
      // выполняем поиск
      this.doSearch().then(() => {
        // переключаем на страницу результатов
        this.setSearchMode();
      }).catch(err => {
        console.log(err.response.statusText)
      })
    },
    onClear() {
      console.log('onClear')
      this.setQString('')
      this.changeMode('start');
      const input = document.getElementById('search-input-vue-mobile');
      input.focus();
    },
    hideMe() {
      this.closeSearch()
    },
    debounceInput: _.debounce(function () {
      this.autocomplete(this.q_param)
          .catch(err => {
            console.log(err)
          })
    }, 500)
  },
  components: {
    Tips
  }
}
</script>